import { render, staticRenderFns } from "./NewEvents.vue?vue&type=template&id=113432b8&scoped=true&"
import script from "./NewEvents.vue?vue&type=script&lang=js&"
export * from "./NewEvents.vue?vue&type=script&lang=js&"
import style0 from "./NewEvents.vue?vue&type=style&index=0&id=113432b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113432b8",
  null
  
)

component.options.__file = "NewEvents.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VIcon,VLayout,VListTile,VListTileContent,VListTileTitle})
